export const faq: Array<{ text: string, title: string }> = [
  {
    text: '<p>Para aquisição do produto Cartão de TODOS Sonhos, o filiado pagará o valor de R$ 30,90 relativo à taxa de adesão e R$ 34,90 relativo as mensalidades.</p>',
    title: 'Qual é o valor?'
  },
  {
    text: '<p>Não. Haverá uma única cobrança de R$34,90.</p>',
    title: 'Será cobrado separadamente?'
  },
  {
    text: '<p>Cartão de Débito e Crédito. Caso o filiado já tenha outro meio de pagamento cadastrado, ao adquirir o Cartão de TODOS Sonhos, esse meio será atualizado para o utilizado na nova compra.</p>',
    title: 'Válido para quais meios de pagamento?'
  },
  {
    text: '<p>Site, Franquias, Televendas, App Vendedor e Link do Vendedor.</p>',
    title: 'Canais participantes:'
  },
  {
    text: '<p>Não. Filiados atuais poderão fazer o upgrade diretamente nas franquias.</p>',
    title: 'Exclusivo para novos filiados?'
  },
  {
    text: '<p>Não. Não haverá carteirinha exclusiva para esse benefício.</p>',
    title: 'Cartão de TODOS Sonhos terá carteirinha própria?'
  },
  {
    text: '<p>Todos os filiados adimplentes, novos e antigos.</p>',
    title: 'Quem pode concorrer?'
  },
  {
    text: '<p>Todos os sábados, às 20h30, dentro do programa Sabadão de TODOS.</p>',
    title: 'Quando acontecem os sorteios?'
  },
  {
    text: '<p>Cada Número da Sorte é válido apenas para o sorteio daquela semana. Toda semana você recebe um novo número, gerado automaticamente.</p>',
    title: 'Meu número da sorte vale por quanto tempo?'
  },
  {
    text: '<p>Até 1h30 minutos antes do sorteio. (ou seja, até às 20h) já valem para o sorteio do mesmo sábado! Números da sorte gerados a partir de Sábado, 18:30:01, serão sorteados no sábado seguinte.</p>',
    title: 'Até que horas a compra vale para o sorteio do mesmo dia?'
  },
  {
    text: '<p>O número é enviado no ato da compra para o e-mail cadastrado.</p>',
    title: 'Quanto tempo leva para receber o número após a aquisição?'
  },
  {
    text: '<p>O filiado deve estar adimplente.</p>',
    title: 'Quais as condições para recebimento do prêmio?'
  },
  {
    text: '<p>O filiado receberá seu número por e-mail, em caso de esquecimento ou perda do Número da Sorte o filiado deve acessar a área logada, a qual o link será enviado para o e-mail cadastrado, onde terá acesso ao histórico de sorteios passados, futuros e números da sorte ativos. Em caso de dúvidas acesse o link: <a href="https://vivasorteoficial.com.br/autenticar" target="blank" rel="noopener noreferrer">https://vivasorteoficial.com.br/autenticar</a></p>',
    title: 'Como eu recebo e confiro meu número da sorte?'
  },
  {
    text: '<p>Não. O número da sorte é exclusivo para o titular do Cartão de TODOS.</p>',
    title: 'Dependentes poderão participar do sorteio?'
  },
  {
    text: '<p>Colaboradores das franquias Cartão de TODOS, da TODOS Empreendimentos, GT7 e Refuturiza não são elegíveis para participação nos sorteios do Cartão de TODOS Sonhos. Da mesma forma, o produto não admite contratos corporativos, apenas vendas individuais. colaboradores do Amor Saúde estão liberados para adquirir, desde que realize o pagamento da mensalidade de 34,90 de forma individual e com recursos próprios.<p/>',
    title: 'Colaboradores podem participar?'
  },
  {
    text: '<p>É uma oportunidade concedida para quem é filiado ao Cartão de TODOS Sonhos de escrever uma carta para o programa Sabadão de TODOS e ter seu sonho realizado.</p>',
    title: 'O que é o “Realize seu Sonho”?'
  },
  {
    text: '<p>Para participar, basta acessar o link enviado para o e-mail cadastrado, e preencher o formulário contando qual é o seu sonho.</p>',
    title: 'Como participar?'
  },
  {
    text: '<p>Se o seu sonho for o escolhido do dia, você receberá um aviso, por e-mail, telefone ou até mesmo durante a programação do nosso programa de TV. Fique de olho!</p>',
    title: 'Como vou saber se meu sonho foi escolhido?'
  },
  {
    text: '<p>Um sonho por dia, ou seja, até 30 sonhos realizados por mês.</p>',
    title: 'Quantos sonhos são realizados por mês?'
  },
  {
    text: '<p>Tem um limite, sim. Você pode enviar até 1 sonho (ou carta) por semana. Mas não precisa se preocupar, sua história será lida com carinho e atenção.</p>',
    title: 'Quantas cartas o filiado pode enviar?'
  },
  {
    text: `
      <p>Todo mês, o filiado que adquiriu o Cartão de TODOS SONHOS, terá disponível um ebook na plataforma do Refuturiza Áudio e Livros. O acesso é vitalício e cada mês o filiado ganhará um ebook diferente, além de ter acesso a diversos outros livros.</p>
      <br />
      <ul>
        <li>O filiado receberá via email as credenciais de acesso e as instruções para realizar o login na plataforma.</li>
        <li><a href="">Acesso ao Refuturiza Áudio e Livros via site</a></li>
        <li><a href="https://play.google.com/store/apps/details?id=com.ubook.refuturiza&hl=pt_BR">Acesso via app Android</a></li>
        <li><a href="https://www.refuturizaaudioelivros.com.br/comofunciona">Base de conhecimento Refuturiza</a></li>
      </ul>
    `,
    title: 'O que é a plataforma Áudio e Livros?'
  },
  {
    text: '<p>É possível o cancelamento do serviço Cartão de TODOS Sonhos através das franquias, mantendo o produto Cartão de TODOS padrão.</p>',
    title: 'E se o filiado quiser cancelar?'
  },
  {
    text: '<p>A Carta dos Sonhos é uma ação exclusiva para filiados ao Cartão de TODOS Sonhos. Nela, você pode escrever uma carta contando sua história e o sonho que deseja realizar. Toda semana, uma nova história é apresentada no programa Sabadão de TODOS, na Band, e pode ser escolhida para ter o sonho realizado. <a href="https://www.cartaodetodos.com.br/sonhos/carta/">Clique aqui e envie sua carta</a></p>',
    title: 'O que é a Carta dos SONHOS?'
  }
]
